import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export const REGION_STORAGE_KEY = 'ciberlens:selectedRegionId';
export const DATE_STORAGE_KEY = 'ciberlens:selectedDate';

@Injectable({
  providedIn: 'root',
})
export class RegionService {
  private selectedRegionIdSubject = new BehaviorSubject<string | null>('global');
  private selectedDateSubject = new BehaviorSubject<Date | null>(null);

  selectedRegionId$ = this.selectedRegionIdSubject.asObservable();
  selectedDate$ = this.selectedDateSubject.asObservable();

  constructor() {
    this.restoreRegion();
    this.restoreDate();
  }

  setRegion(id: string | null) {
    this.selectedRegionIdSubject.next(id);

    if (id) {
      localStorage.setItem(REGION_STORAGE_KEY, id);
    } else {
      localStorage.removeItem(REGION_STORAGE_KEY);
    }
  }

  getCurrentRegion(): string | null {
    return this.selectedRegionIdSubject.value;
  }

  setDate(date: Date | null) {
    if (!date) {
      this.selectedDateSubject.next(null);
      localStorage.removeItem(DATE_STORAGE_KEY);
      return;
    }

    const normalized = new Date(date);
    this.selectedDateSubject.next(normalized);
    localStorage.setItem(DATE_STORAGE_KEY, normalized.toISOString());
  }

  getDate(): Date | null {
    const current = this.selectedDateSubject.value;
    return current ? new Date(current) : null;
  }

  clearPersistedState() {
    localStorage.removeItem(REGION_STORAGE_KEY);
    localStorage.removeItem(DATE_STORAGE_KEY);
    this.selectedRegionIdSubject.next('global');
    this.selectedDateSubject.next(null);
  }

  private restoreRegion() {
    const stored = localStorage.getItem(REGION_STORAGE_KEY);
    if (stored) {
      this.selectedRegionIdSubject.next(stored);
    }
  }

  private restoreDate() {
    const stored = localStorage.getItem(DATE_STORAGE_KEY);
    if (!stored) {
      return;
    }

    const parsed = new Date(stored);
    if (!isNaN(parsed.getTime())) {
      this.selectedDateSubject.next(parsed);
    } else {
      localStorage.removeItem(DATE_STORAGE_KEY);
    }
  }
}
